module.exports = str => str.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase())
